module.exports = "<select #focusField class=\"form-control\" [(ngModel)]=\"selectedYear\" [attr.name]=\"name ? name : null\" [attr.required]=\"required ? '' : null\">\r\n    <option [ngValue]=\"undefined\">Please select...</option>\r\n    <option *ngFor=\"let year of yearValues\" [ngValue]=\"year\">{{year}}</option>\r\n</select>";


//////////////////
// WEBPACK FOOTER
// ./Client/app/components/common/yearselector/yearselector.component.html
// module id = 1278
// module chunks = 0